import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { GridColDef, GridRowsProp } from "@mui/x-data-grid"

import Table from "@/components/table/Table"
import Pagination from "@/components/table/Pagination"
import { Device, DeviceTableCol } from "@/types/device"

import "./equipmentsTable.scss"

const TYPE_ORDER = ["Dock", "Live Hub", "Cell"]
const EQUIPMENT_TYPE_MAX_WIDTH = 150
const EQUIPMENT_SERIAL_NUMBER_MAX_WIDTH = 527

export default function EquipmentsTable({
  data,
  isLoading,
  paginationModel,
  setPaginationModel,
}: {
  data?: Device[]
  isLoading?: boolean
  paginationModel?: {
    page: number
    pageSize: number
  }
  setPaginationModel?: (model: { page: number; pageSize: number }) => void
}) {
  const { t } = useTranslation()
  const [rows, setRows] = useState<GridRowsProp<Device>>([])

  useEffect(() => {
    if (!data) {
      return
    }
    setRows(
      data
        .map((device) => ({
          id: device.serialNumber,
          type: device.type,
          firmwareVersion: device.firmwareVersion,
          ...device,
        }))
        .sort((a, b) => {
          if (a.type && b.type) {
            return TYPE_ORDER.indexOf(a.type) - TYPE_ORDER.indexOf(b.type)
          } else {
            return a.serialNumber.localeCompare(b.serialNumber)
          }
        }),
    )
  }, [data])

  const columns: GridColDef<DeviceTableCol>[] = [
    {
      field: "type",
      renderHeader: () => t("type"),
      maxWidth: EQUIPMENT_TYPE_MAX_WIDTH,
      flex: 1,
      sortable: false,
    },
    {
      field: "serialNumber",
      renderHeader: () => t("name"),
      maxWidth: EQUIPMENT_SERIAL_NUMBER_MAX_WIDTH,
      flex: 1,
      sortable: false,
    },
    {
      field: "firmwareVersion",
      renderHeader: () => t("firmwareVersion"),
      flex: 1,
      sortable: false,
    },
  ]

  return (
    <Table
      rows={rows}
      columns={columns}
      disableColumnResize
      disableVirtualization
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 10,
          },
        },
      }}
      pagination
      paginationModel={paginationModel}
      onPaginationModelChange={setPaginationModel}
      slots={{
        pagination: Pagination,
      }}
      loading={isLoading}
      className="EquipmentsTableCont"
    />
  )
}
